var _circle, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGroup239993 = function SvgGroup239993(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9706,
    cy: 16.9707,
    r: 10.5,
    transform: "rotate(-45 16.9706 16.9707)",
    fill: "#2555EF",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.419 22.0446L17.4194 11.8966C17.4194 11.6488 17.2186 11.4479 16.9707 11.4479C16.7229 11.4479 16.522 11.6487 16.522 11.8966L16.5218 22.0446C16.5218 22.2924 16.7228 22.4933 16.9706 22.4932C17.2183 22.4932 17.419 22.2923 17.419 22.0446Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.314286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0441 16.5216L11.8968 16.522C11.6489 16.522 11.4479 16.723 11.448 16.971C11.4481 17.2188 11.649 17.4196 11.8968 17.4196L22.0441 17.4192C22.292 17.4192 22.493 17.2182 22.4929 16.9702C22.4928 16.7224 22.2919 16.5216 22.0441 16.5216Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.314286
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup239993, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group 239993.b0c97a88.svg";
export { ForwardRef as ReactComponent };